export default __webpack_public_path__ + "45fe82d488bdf0629c764dca44e2ac5b.png";